import React from "react";
import { Modal, Box, Button, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CryptoPaymentWarningModal = ({ open, handleProceed, handleClose }) => {
    return (
        <Modal open={open} onClose={handleClose} aria-labelledby="crypto-warning-modal">
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: 500, md: 600 },
                    bgcolor: "#1a1a1a",
                    boxShadow: 24,
                    p: { xs: 3, md: 4 },
                    borderRadius: "20px",
                    border: "1px solid #333",
                    fontFamily: "Manrope, sans-serif",
                }}
            >
                {/* Close Button */}
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 16,
                        top: 16,
                        color: "#fff",
                        "&:hover": {
                            bgcolor: "rgba(255, 255, 255, 0.1)",
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* Title */}
                <Typography
                    id="crypto-warning-modal"
                    variant="h5"
                    component="h2"
                    sx={{
                        color: "#fff",
                        fontWeight: 600,
                        mb: 3,
                        fontSize: { xs: "1.25rem", md: "1.5rem" },
                        fontFamily: "Manrope, sans-serif",
                    }}
                >
                    Crypto Payment Warning
                </Typography>

                {/* Content */}
                <Typography
                    sx={{
                        color: "#d1d1d1",
                        mb: 2.5,
                        fontSize: { xs: "0.95rem", md: "1rem" },
                        lineHeight: 1.6,
                        fontFamily: "Manrope, sans-serif",
                    }}
                >
                    You are proceeding with a cryptocurrency payment.
                </Typography>

                <Typography
                    sx={{
                        color: "#d1d1d1",
                        mb: 2.5,
                        fontSize: { xs: "0.95rem", md: "1rem" },
                        lineHeight: 1.6,
                        fontFamily: "Manrope, sans-serif",
                    }}
                >
                    Please ensure that the correct coin,{" "}
                    <Box component="span" sx={{ color: "#fff", fontWeight: 600 }}>
                        ETH, USDC, or USDT
                    </Box>
                    , is sent on the correct network,{" "}
                    <Box component="span" sx={{ color: "#fff", fontWeight: 600 }}>
                        ERC20 (Ethereum network) or TRC20 (TRON network)
                    </Box>
                    .
                </Typography>

                <Typography
                    sx={{
                        color: "#d1d1d1",
                        mb: 4,
                        fontSize: { xs: "0.95rem", md: "1rem" },
                        lineHeight: 1.6,
                        fontFamily: "Manrope, sans-serif",
                    }}
                >
                    Sending the wrong coin or using the wrong network will result in the
                    automation not working and your account not being delivered, and funds
                    may also be lost.{" "}
                    <Box component="span" sx={{ color: "#fff", fontWeight: 600 }}>
                        Please proceed with caution.
                    </Box>
                </Typography>

                {/* Action Buttons */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 2,
                        mt: 3,
                    }}
                >
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        sx={{
                            color: "#fff",
                            borderColor: "#555",
                            textTransform: "none",
                            fontSize: "1rem",
                            px: 3,
                            py: 1,
                            borderRadius: "11px",
                            fontFamily: "Manrope, sans-serif",
                            "&:hover": {
                                borderColor: "#777",
                                bgcolor: "rgba(255, 255, 255, 0.05)",
                            },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleProceed}
                        sx={{
                            bgcolor: "#ef4444",
                            color: "#fff",
                            textTransform: "none",
                            fontSize: "1rem",
                            px: 3,
                            py: 1,
                            borderRadius: "11px",
                            fontFamily: "Manrope, sans-serif",
                            "&:hover": {
                                bgcolor: "#dc2626",
                            },
                        }}
                    >
                        Proceed
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default CryptoPaymentWarningModal;
